import { useState } from "react"
import { Button, Toast } from "../../../components"
import FormItem from "../../InfoUser/ChangePassword/FormItem/FormItem"
import RegisterContainer from "../../Register/RegisterContainer"
import HeaderRegister from "../../Register/HeaderRegister"
import classNames from "classnames/bind"
import styles from './ChangePassword.module.css'
import { isValidateConfirm, isValidatePassword } from "../../../utils"
import axiosClient from "../../../services/axiosClient"
import { useStoreContext } from "../../../hooks/useStoreContext"
import { useNavigate } from "react-router-dom"

const cx = classNames.bind(styles)
function ChangePassword() {
    const [newPassword, setNewPassword] = useState('')
    const [confirmPassword, setConfirmPassword] = useState('')
    // eslint-disable-next-line
    const [token, dispatch] = useStoreContext()
    const navigate = useNavigate()
    const handleSubmitForm = () => {
        if (isValidatePassword(newPassword) && isValidateConfirm(newPassword, confirmPassword)) {
            const changePassword = async () => {
                try {
                    const res = await axiosClient.post('/authenticator/password-reset/confirm',
                        { password: newPassword, token: token.tokenUser, username: token.emailForgotPassword })
                    navigate('/forgot-password/change-password/succes')
                    return res
                } catch (error) {
                    if (error?.response?.status === 400) {
                        Toast.open('Mật khẩu bạn đã từng sử dụng, vui lòng chọn mật khẩu khác', 'danger')
                    } else {
                        Toast.open('Không thể thay đổi mật khẩu', 'danger')
                    }
                }
            }
            changePassword()
        } else {
            // Toast.open('Không thể thay đổi mật khẩu', 'danger')
        }
    }

    const handleTypeNewPassword = (data) => {
        setNewPassword(data)
    }

    const handleTypeConfirmPassword = (data) => {
        setConfirmPassword(data)
    }
    return (
        <>
            <div id="__notification"></div>
            <RegisterContainer>
                <HeaderRegister header={'Đổi mật khẩu'} backTo={'/login'} />
                <form className={cx('form-change-password')} onSubmit={handleSubmitForm}>
                    <FormItem
                        label={'Mật khẩu mới'}
                        name={'newPassword'}
                        values={newPassword}
                        onChange={handleTypeNewPassword}
                        type={'password'}
                        warning={'Dài 6 - 20 kí tự, bao gồm cả chữ, số, viết hoa, viết thường và cả những kí tự đặc biệt'}
                        rules={[
                            {
                                isRequire: true,
                                mess: 'Mật khẩu không được để trống'
                            },
                        ]}
                    />
                    <FormItem
                        label={'Nhập lại mật khẩu'}
                        name={'confirmPassword'}
                        values={confirmPassword}
                        onChange={handleTypeConfirmPassword}
                        type={'password'}
                        rules={[
                            {
                                isRequire: true,
                                mess: 'Mật khẩu không được để trống'
                            },
                            {
                                confirm: newPassword,
                                mess: 'Mật khẩu nhập lại không giống'
                            }
                        ]}
                    />
                    <div className={cx('button-change')}>
                        <Button
                            onClick={handleSubmitForm}
                            title="Xác nhận"
                        />
                    </div>
                </form>
            </RegisterContainer>
        </>
    )
}

export default ChangePassword